import { PAGE_HEADER_HEIGHT } from '@/catalog-apps/components/config'
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/shadcn/breadcrumb'
import { IconRightChevronOutline } from '@icons/IconRightChevronOutline'
import { Link } from 'react-router'
import { useCurrentWorkspace } from './useCurrentWorkspace'
import { IconWebcastOutline } from '@icons/IconWebcastOutline'

export function WorkspacesBreadcrumbs({ title }: { title: string }) {
  const { workspaceId, application, project } = useCurrentWorkspace()
  return (
    <div
      style={{ height: PAGE_HEADER_HEIGHT }}
      className="bg-offwhite/80 sticky top-0 z-20 flex w-full items-center justify-between gap-10 border-b py-2 backdrop-blur"
    >
      <Breadcrumb className="backdrop-blur">
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link className="hover:text-primary hover:underline" to="/workspaces">
                Workspaces
              </Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator>
            <IconRightChevronOutline />
          </BreadcrumbSeparator>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link className="flex items-center hover:text-primary hover:underline" to={`/workspaces/${workspaceId}`}>
                <IconWebcastOutline className="mr-2" />
                {`${application} | ${project}`}
              </Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator>
            <IconRightChevronOutline />
          </BreadcrumbSeparator>
          <BreadcrumbItem>
            <BreadcrumbPage>{title}</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
    </div>
  )
}
